import Warning from './Warning'
export default Warning